import { Component, EventEmitter, Output } from '@angular/core';
import { PaymentSourceFinancialService } from 'src/app/revenue/shared/payment-source/financial-service-payment-source.service';
import { PaymentSource } from 'src/app/revenue/shared/payment-source/payment-source.model';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-payment-source-edit-dialog',
  templateUrl: './payment-source-edit-dialog.component.html',
  styleUrls: ['./payment-source-edit-dialog.component.less'],
    standalone: false
})
export class PaymentSourceEditDialogComponent {
  @Output() paymentSourceSaved = new EventEmitter<PaymentSource>();

  isEditing: boolean = false;
  show: boolean = false;
  isSaving: boolean = false;
  loadingPaymentSource: boolean = false;
  paymentSource = {} as PaymentSource;
  originalPaymentSource: string;

  constructor(private _paymentSourceService: PaymentSourceFinancialService, private _notificationService: NotificationService) {}

  public open(paymentSource?: string) {
    this.isEditing = false;
    this.show = true;
    this.paymentSource = {} as PaymentSource;

    if (paymentSource) {
      this.isEditing = true;
      this.loadingPaymentSource = true;
      this.originalPaymentSource = paymentSource;
      this._paymentSourceService
        .getPaymentSource(paymentSource)
        .then((paymentSource) => {
          this.paymentSource = paymentSource;
        })
        .finally(() => (this.loadingPaymentSource = false));
    }
  }

  public save() {
    this.isSaving = true;
    let crudPromise: Promise<string>;
    if (this.isEditing) {
      crudPromise = this._paymentSourceService.updatePaymentSource(this.originalPaymentSource, this.paymentSource);
    } else {
      crudPromise = this._paymentSourceService.createPaymentSource(this.paymentSource);
    }

    crudPromise
      .then(() => {
        this.paymentSourceSaved.emit(this.paymentSource);
        this._notificationService.translateSuccess('common.saved-successfully');
        this.close();
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      })
      .finally(() => (this.isSaving = false));
  }

  public close() {
    this.show = false;
  }
}
